import IntercomClass from '@shared/services/Intercom';
import { getEnvVariables } from './env';

export class IntercomInstance {
  private static instance: IntercomClass;

  public static getInstance() {
    const { INTERCOM_APP_ID, INTERCOM_DOMAIN } = getEnvVariables();
    if (!IntercomInstance.instance) {
      // https://developers.intercom.com/installing-intercom/web/attributes-objects/#messenger-attributes
      IntercomInstance.instance = new IntercomClass({
        app_id: INTERCOM_APP_ID,
        api_base: INTERCOM_DOMAIN,
        alignment: 'left',
        vertical_padding: 80,
        hide_default_launcher: true,
        custom_launcher_selector: '.need-help',
      });
    }
    return IntercomInstance.instance;
  }
}
